<script setup lang="ts">
import HelpIconTooltip from '../elements/HelpIconTooltip.vue';

import type { ICustomField } from '@nova/core';

/**
 * Label component for custom fields.
 * Displays field label with optional required indicator.
 */
const { field, htmlFor } = defineProps<{
  field: ICustomField;
  htmlFor?: string;
}>();
</script>

<template>
  <label class="d-flex flex-row align-center ga-1 custom-field-label" :for="htmlFor">
    <span class="typography-body-sm-bold text--color-text-primary">{{ field.label }}</span>

    <help-icon-tooltip v-if="field.description">
      {{ field.description }}
    </help-icon-tooltip>
    <slot name="append"></slot>
  </label>
</template>
